// extracted by mini-css-extract-plugin
export default {"shareUrl":"ShareDialog_shareUrl_nw4iB","shareError":"ShareDialog_shareError_gQ24S","copyButton":"ShareDialog_copyButton_OPSzL"};